export default {
  online_shop: 'Boutique en ligne',
  storefront: 'Vitrine',
  reservations: 'Réservations',
  import: 'Importation',
};
